import { useMemo, useContext } from "react"
import PropTypes from "prop-types"
import { isEqual } from "lodash"
import ContributorsDataIntegrator from "gatherers/contributors-data-integrator"
import { isInstrumentWithoutGMV } from "helpers/metrics/utils"
import { CLASSIFICATIONS_SHAPE } from "helpers/shapes/asset-view"
import { useTemplateGatherers } from "connected-components/dashboard/hooks/use-template-gatherers"
import { useModelId } from "connected-components/dashboard/hooks/use-model-id"
import NewTrade from "./renderers"

// [TODO-JG] Support trading a specific security within a group
export default function AddTrade({ context, classifications, currentGrouping = null, hasFilters = false }) {
  const { instrument, base, addTrade, secondInstrument, tradedPosition, setTradedPosition, tradedPositionField, filter, actionsBase, isExpanded, trades } = useContext(context)
  const modelId = useModelId()
  const hideEconomicExposure = useMemo(() => isInstrumentWithoutGMV(instrument?.type), [instrument])

  const gatherers = useTemplateGatherers(context, "trade", {
    classifications,
    target: secondInstrument,
  })

  return (
    <ContributorsDataIntegrator
      gatherers={gatherers}
      Renderer={NewTrade}
      rendererProps={{
        modelId,
        base,
        addTrade,
        tradedPosition,
        tradedPositionField,
        setTradedPosition,
        hideEconomicExposure,
        filter,
        isActiveTradingDisabled: actionsBase && !isEqual(actionsBase, base),
        isExpanded,
        trades,
        currentGrouping,
        hasFilters,
      }}
    />
  )
}

AddTrade.propTypes = {
  context: PropTypes.shape({
    modelId: PropTypes.string.isRequired,
    instrument: PropTypes.object.isRequired,
    date: PropTypes.string.isRequired,
    secondInstrument: PropTypes.object.isRequired,
    base: PropTypes.object,
  }),
  classifications: CLASSIFICATIONS_SHAPE.isRequired,
  currentGrouping: PropTypes.object,
  hasFilters: PropTypes.bool,
}
